import { combineReducers } from 'redux';

import { reducer as formReducer } from 'redux-form';
import dropdowns from './dropdowns';
import registrationPage from './registration';
import auditc from './auditc';
import progress from './progress';
import activepathways from './activepathways';
import pathway from './pathway';
import { activities, activityFavourites } from './activities';
import { articles, articleFavourites } from './articles';
import pathwayplan from './pathwayplan';
import tasks from './tasks';
import notes from './notes';
import plans from './plans';
import taskfilter from './taskfilter';
import loginerror from './loginerror';
import login from './login';
import diaries from './diaries';
import activityfilter from './activityfilter';
import activityfilters from './activityfilters';
import selectedbct from './selectedbct';
import passwordreg from './passwordreg';
import passwordupdate from './passwordupdate';
import pathwaybarriers from './pathwaybarriers';
import pathwayplanselected from './pathwayplanselected';
import assessmentPage from './assessment';
import validatedhash from './validateHash';
import postassessment from './postassessment';

const Reducers = combineReducers({
  form: formReducer,
  dropdowns,
  registrationPage,
  auditc,
  progress,
  activepathways,
  activities,
  activityFavourites,
  articles,
  articleFavourites,
  pathway,
  pathwayplan,
  tasks,
  taskfilter,
  loginerror,
  login,
  notes,
  plans,
  diaries,
  activityfilter,
  activityfilters,
  selectedbct,
  passwordreg,
  passwordupdate,
  pathwaybarriers,
  pathwayplanselected,
  assessmentPage,
  validatedhash,
  postassessment,
});

export default Reducers;



// WEBPACK FOOTER //
// ./src/Reducers/index.js